/* eslint-disable no-console */
interface AlertOptions {
  title: string;
  message: string;
  buttons?: Array<{
    text: string;
    onPress?: () => void;
  }>;
  cancelable?: boolean;
  closeButton?: boolean;
}

type AlertCallback = (options: AlertOptions) => void;

class AlertService {
  private static instance: AlertService;
  private alertCallbacks: AlertCallback[] = [];

  public static getInstance(): AlertService {
    if (!AlertService.instance) {
      AlertService.instance = new AlertService();
    }
    return AlertService.instance;
  }

  public subscribe(callback: AlertCallback): () => void {
    this.alertCallbacks.push(callback);

    return () => {
      this.alertCallbacks = this.alertCallbacks.filter((cb) => cb !== callback);
    };
  }

  private notify(options: AlertOptions): void {
    this.alertCallbacks.forEach((callback) => {
      try {
        callback(options);
      } catch (error) {
        if (import.meta.env.NODE_ENV !== 'production') {
          console.error('Error in alert callback:', error);
        }
      }
    });
  }

  public custom(options: AlertOptions): void {
    this.notify({
      cancelable: true,
      closeButton: true,
      ...options,
    });
  }

  public error(
    options: Omit<AlertOptions, 'title'> & { title?: string }
  ): void {
    this.notify({
      title: options.title || 'Erro',
      cancelable: true,
      closeButton: true,
      ...options,
    });
  }
}

export default AlertService;
